module.exports = __webpack_public_path__ + "img/your-business-emotions.bf788b0d.png";